<template>
  <v-dialog
    v-model="internalLoading"
    persistent
    max-width="290"
  >
    <v-card>
      <v-card-text class="text-center">
        <v-progress-circular
          indeterminate
          color="teal"
          size="50"
          width="13"
          class="mb-3"
        ></v-progress-circular>
        <br />
        <h2>Carregando dados...</h2>
        <br />
        <h1>Aguarde</h1>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "QuizLoadScreen",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    internalLoading: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", val);
      },
    },
  },
};
</script>

<style scoped>
/* Adicione estilos adicionais, se necessário */
</style>
